import { Form } from "antd";
import React, { useState } from "react";
import {
  movimientoRemoverStartAdd,
  showFormRemoveMovements,
} from "../../../../actions/inventario";
import { useDispatch, useSelector } from "react-redux";
import { FormUi } from "../../../ui/FormUi";
import { DetalleSalidaModal } from "./DetalleSalidaModal";
import { RemoveForm } from "./RemoveForm";

const initialValues = (data = {}) => ({
  inventario: data?.id || "",
  producto: data?.producto || "",
  nombreproducto: data?.nombreproducto || "",
  almacenorigen: data?.almacen || "",
  nombrealmacen: data?.nombrealmacen || "",
  stockactual: data?.stockactual || "",
  almacendestino: data?.almacen || null,
  cantidad: parseFloat(data?.cantidad || 0),
  unidadmedida: data?.unidadmedida || null,
  series: data?.series || [],
  lotes: data?.lotes || [],
  manejalotes: data?.manejalotes || false,
  manejaseries: data?.manejaseries || false,
});

export const RemoveScreen = () => {
  const [form] = Form.useForm();
  const manejaseries = Form.useWatch("manejaseries", form);
  const manejalotes = Form.useWatch("manejalotes", form);
  const cantidad = Form.useWatch("cantidad", form);
  const { inventarioActive } = useSelector((state) => state.inventario);
  const { activeEmpleado } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const showModal = () => {
    setOpen(true);
  };
  const hideModal = () => {
    setOpen(false);
  };
  const handleSave = (values) => {
    const valuesLotes = values?.lotes
      ?.filter((e) => e.cantidad_ingresada !== null)
      .map((e) => ({
        ...e,
        cantidad: e.cantidad_ingresada,
      }));
    const valuesData = {
      empresa: activeEmpleado?.empresa?.id,
      almacenorigen: values?.almacenorigen,
      almacendestino: values?.almacenorigen,
      detallescomprobantemovimiento: [
        {
          inventario: values?.inventario,
          cantidad: values?.cantidad,
          unidadmedida: values?.unidadmedida,
          lotes: valuesLotes,
          series: values?.series?.filter((item) => item.selected === true),
        },
      ],
    };
    dispatch(movimientoRemoverStartAdd(valuesData));
    dispatch(showFormRemoveMovements(false));
  };
  return (
    <Form.Provider
      onFormFinish={(name, { values, forms }) => {
        if (name === "FormDetalle") {
          const { FormMovimietoRetirarAlmacen } = forms;
          FormMovimietoRetirarAlmacen.setFieldValue("lotes", values?.lotes);
          FormMovimietoRetirarAlmacen.setFieldValue("series", values?.series);
        }
        setOpen(false);
      }}
    >
      <FormUi
        name="FormMovimietoRetirarAlmacen"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues(inventarioActive)}
        handleSubmit={handleSave}
      >
        <RemoveForm onOpenModal={showModal} />
      </FormUi>
      <DetalleSalidaModal
        series={form.getFieldValue("series")}
        lotes={form.getFieldValue("lotes")}
        manejalotes={manejalotes}
        manejaseries={manejaseries}
        cantidad={cantidad}
        open={open}
        onCancel={hideModal}
      />
    </Form.Provider>
  );
};
